import React, { type ComponentProps } from 'react'
import { FlowGrid, useContainerWidth } from '@fs/zion-ui'
import AboutThisTreeContent from '../../components/details/researcher-trees/AboutThisTreeContent'
import UploadReport from './UploadReport'

export default function SettingsPageAboutThisTreeWrapper({
  gedcomData,
}: ComponentProps<typeof AboutThisTreeContent>): JSX.Element {
  const atWidth = useContainerWidth()
  return (
    <FlowGrid gutters="sm" columnCount={atWidth({ default: 1, sm: 2 })}>
      <AboutThisTreeContent gedcomData={gedcomData} />
      <UploadReport />
    </FlowGrid>
  )
}
